import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, children }) {
  return (
    <main
      data-testid="legal-page"
      className="min-h-screen bg-[#F7F9FB] text-[#1F2937]"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-10 pt-28 pb-24">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-sm font-medium text-[#1F2937]/65 hover:text-[#2E89C4] transition mb-10"
        >
          <ArrowLeft size={16} />
          Zurück zur Startseite
        </Link>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1] mb-10">
          {title}
        </h1>
        <article className="prose-content text-[15px] leading-relaxed text-[#1F2937]/85 space-y-4">
          {children}
        </article>
      </div>
    </main>
  );
}
